import PropTypes from 'prop-types'
import Icon from 'components/common/icon'
import ICONS from 'components/common/icon/const'
import ResponsiveImage from 'components/images/responsive-image'
import styles from './styles.scss'

const VideoTeaser = ({ teaser, isPhone, titleImg, onClick }) => (
  <section className="purpose-vid__wrapper">
    <style jsx>{styles}</style>
    <video
      className="purpose-vid__self"
      playsInline
      loop
      muted
      autoPlay
      preload="auto"
    >
      <source src={teaser} type="video/mp4" />
    </video>
    {!isPhone && (
      <div className="purpose-vid__title">
        <ResponsiveImage
          className="purpose-had__title"
          imgRatio={titleImg.ratio}
          src={titleImg.src}
        />
        <div
          className="purpose-had__arrow-wrapper"
          role="button"
          tabIndex="0"
          onClick={onClick}
          onKeyDown={onClick}
        >
          <Icon
            className="icon-arrow-white-bottom-new"
            src={ICONS.dropdownSmallGhost}
          />
        </div>
      </div>
    )}
  </section>
)

VideoTeaser.defaultProps = {
  onClick: null,
  teaser: '',
  titleImg: undefined,
}

VideoTeaser.propTypes = {
  onClick: PropTypes.func,
  teaser: PropTypes.string,
  isPhone: PropTypes.bool.isRequired,
  titleImg: PropTypes.shape({
    ratio: PropTypes.number,
    src: PropTypes.string,
  }),
}

export default VideoTeaser
